/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { ApiContext } from '../../../../context/ApiContext';
import { IEmaasEnergyUsageComponentDataAreaV2 } from '../../IEnergyManagementProps';
import {
  convertUnitForPerformanceGraphV2,
  getPerformanceGraphDataV2,
  getSpanDetails
} from '../../../shared/Utils/Utils';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import CommonEnergyGraphComponent from '../../../shared/EnergyGraphKPI/CommonEnergyGraphComponent';
interface IEmaasNILMEnergyUsageGraphComponentProps {
  data: IEmaasEnergyUsageComponentDataAreaV2;
  viewType?: string;
}

export const EmaasNILMEnergyUsageGraphComponent = (
  props: IEmaasNILMEnergyUsageGraphComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { onEnergyUsageViewDetailsClick, userPreferedUnit } = apiContext;
  const onViewDetailsClick = () => {
    if (onEnergyUsageViewDetailsClick) {
      onEnergyUsageViewDetailsClick();
    }
  };

  const {
    nilmAggregation,
    aggregationsStartDate,
    aggregationsEndDate,
    energyMeasurementUnit
  } = data;

  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }
  fromUnit = userPreferedUnit as any;

  const SpanDetails = getSpanDetails(
    aggregationsStartDate,
    aggregationsEndDate
  );

  const convertedPerformanceData = convertUnitForPerformanceGraphV2(
    nilmAggregation.energyUsageAggregation,
    fromUnit //energyMeasurementUnit
  );

  const { displayUnit: performanceDisplayUnit } = convertedPerformanceData;

  const comparisonData = getPerformanceGraphDataV2(
    nilmAggregation.energyUsageAggregation,
    energyMeasurementUnit,
    performanceDisplayUnit,
    data.intervalType,
    ConversionType.ELECTRICITY
  );

  const energyComponentProps = {
    isNILM: true,
    onViewDetailsClick: onViewDetailsClick,
    graphData: {
      chartSeries: comparisonData,
      startTime: aggregationsStartDate,
      endTime: aggregationsEndDate,
      aggregationType: data.intervalType
    },
    dateData: SpanDetails
  };

  return <CommonEnergyGraphComponent {...energyComponentProps} />;
};
export default memo(EmaasNILMEnergyUsageGraphComponent);
